export default __webpack_public_path__ + "static/media/project-closed-status.43cc87df.svg";